import { Grid } from '@mui/material';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
  gridtemplatecolumns: repeat(3, 1fr);
`;
